import './bootstrap'

// Plugins
import Action from './plugins/Action'
import AdyenDropIn from './plugins/AdyenDropIn'
import AutoComplete from './plugins/AutoComplete'
import AutoCompleteToggle from './plugins/AutoCompleteToggle'
import AutoLinks from './plugins/AutoLinks'
import Checkboxes from './plugins/Checkboxes'
import Confirm from './plugins/Confirm'
import Copy from './plugins/Copy'
import CreditCard from './plugins/CreditCard'
import DisableButtonUntilAccept from './plugins/DisableButtonUntilAccept'
import FocusNext from './plugins/FocusNext'
import Input from './plugins/Input'
import InputDate from './plugins/InputDate'
import InputPassword from './plugins/InputPassword'
import InputSelect from './plugins/InputSelect'
import InputSelectOpen from './plugins/InputSelectOpen'
import InputStepper from './plugins/InputStepper'
import InputTextarea from './plugins/InputTextarea'
import IntlPhone from './plugins/IntlPhone'
import Modal from './plugins/Modal'
import Notification from './plugins/Notification'
import PopOut from './plugins/PopOut'
import Status from './plugins/Status'
import Tabs from './plugins/Tabs'
import Tooltip from './plugins/Tooltip'
import XhrForm from './plugins/XhrForm'
import XhrModal from './plugins/XhrModal'

// Components
import Addon from './components/Addon'
import Cart from './components/Cart'
import Donation from './components/Donation'
import Nav from './components/Nav'
import Payment from './components/Payment'
import PaymentStatus from './components/PaymentStatus'
import Tickets from './components/Tickets'
import WildfireResendVerification from './components/WildfireResendVerification'
import EventSchedule from './components/EventSchedule'

// Sentry
import * as Sentry from "@sentry/browser";
import { BrowserTracing } from "@sentry/tracing";
import Feedback from './plugins/Feedback'


window.app.init([
    // Plugins
    { name: 'action', obj: Action },
    { name: 'adyenDropIn', obj: AdyenDropIn },
    { name: 'autoComplete', obj: AutoComplete },
    { name: 'autoCompleteToggle', obj: AutoCompleteToggle },
    { name: 'autoLinks', obj: AutoLinks },
    { name: 'checkboxes', obj: Checkboxes },
    { name: 'confirm', obj: Confirm },
    { name: 'copy', obj: Copy },
    { name: 'creditCard', obj: CreditCard },
    { name: 'disableButtonUntilAccept', obj: DisableButtonUntilAccept },
    { name: 'feedback', obj: Feedback },
    { name: 'focusNext', obj: FocusNext },
    { name: 'input', obj: Input },
    { name: 'inputDate', obj: InputDate },
    { name: 'inputPassword', obj: InputPassword },
    { name: 'inputSelect', obj: InputSelect },
    { name: 'inputSelectOpen', obj: InputSelectOpen },
    { name: 'inputStepper', obj: InputStepper },
    { name: 'inputTextarea', obj: InputTextarea },
    { name: 'intlPhone', obj: IntlPhone },
    { name: 'modal', obj: Modal },
    { name: 'notification', obj: Notification },
    { name: 'popOut', obj: PopOut },
    { name: 'status', obj: Status },
    { name: 'tabs', obj: Tabs },
    { name: 'tooltip', obj: Tooltip },
    { name: 'xhrForm', obj: XhrForm },
    { name: 'xhrModal', obj: XhrModal },

    // Components
    { name: 'addon', obj: Addon },
    { name: 'cart', obj: Cart },
    { name: 'donation', obj: Donation },
    { name: 'nav', obj: Nav },
    { name: 'payment', obj: Payment },
    { name: 'payment-status', obj: PaymentStatus },
    { name: 'tickets', obj: Tickets },
    { name: 'wildfire-resend-verification', obj: WildfireResendVerification },
    { name: 'event-schedule', obj: EventSchedule },
])

Sentry.init({
    dsn: "https://355c1700a0614fc6974ba6fd743a3f73@o53586.ingest.sentry.io/4504486651625472",
    integrations: [new BrowserTracing()],

    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 0.05,
})
